import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const Banner = () => {
    const nordicRunePattern = `
      <svg xmlns="http://www.w3.org/2000/svg" width="150" height="50" viewBox="0 0 150 50">
          <rect width="150" height="50" fill="none"/>
          
          <!-- Large Algiz rune -->
          <line x1="25" y1="5" x2="25" y2="45" stroke="black" stroke-width="4"/>
          <line x1="25" y1="25" x2="5" y2="5" stroke="black" stroke-width="4"/>
          <line x1="25" y1="25" x2="45" y2="5" stroke="black" stroke-width="4"/>
          
          <!-- Mannaz rune in the middle -->
          <line x1="65" y1="5" x2="65" y2="45" stroke="black" stroke-width="3"/>
          <line x1="85" y1="5" x2="85" y2="45" stroke="black" stroke-width="3"/>
          <line x1="65" y1="5" x2="85" y2="25" stroke="black" stroke-width="3"/>
          <line x1="85" y1="5" x2="65" y2="25" stroke="black" stroke-width="3"/>
         
          <!-- Large Algiz rune -->
          <line x1="125" y1="5" x2="125" y2="45" stroke="black" stroke-width="4"/>
          <line x1="125" y1="25" x2="105" y2="5" stroke="black" stroke-width="4"/>
          <line x1="125" y1="25" x2="145" y2="5" stroke="black" stroke-width="4"/>
      </svg>
  `;

    const encodedPattern = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(nordicRunePattern)))}`;

    useEffect(() => {
        const styleTag = document.createElement('style');
        styleTag.innerHTML = `
          @keyframes scroll-right {
            from {
              background-position: 0 0;
            }
            to {
              background-position: 300px 0;
            }
          }

          @keyframes scroll-left {
            from {
              background-position: 0 0;
            }
            to {
              background-position: -300px 0;
            }
          }
        `;

        document.head.appendChild(styleTag);

        return () => {
            document.head.removeChild(styleTag);
        };
    }, []);

    return (
        <Box
            sx={{
                mt: { xs: 7, sm: 8 },
                width: '100%',
                height: 300,
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: {
                    xs: 2,
                    sm: 3,
                },
                textAlign: 'center',
            }}
        >
            {/* Background image box */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: 'url(/banner.webp)',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    filter: 'hue-rotate(20deg) grayscale(100%) brightness(70%)',
                    zIndex: -1,
                }}
            />

            {/* Top border */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    width: '100%',
                    height: '30px',
                    backgroundImage: `url(${encodedPattern})`,
                    backgroundRepeat: 'repeat-x',
                    backgroundSize: 'contain',
                    marginTop: '5px',
                    opacity: 0.5,
                    animation: 'scroll-right 10s linear infinite',
                }}
            />

            {/* Bottom border */}
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    height: '30px',
                    backgroundImage: `url(${encodedPattern})`,
                    backgroundRepeat: 'repeat-x',
                    backgroundSize: 'contain',
                    marginBottom: '5px',
                    opacity: 0.6,
                    animation: 'scroll-left 10s linear infinite',
                }}
            />

            <Box
                sx={{
                    width: '100%',
                    height: 0.6,
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: {
                        xs: 2,
                        sm: 3,
                    },
                    textAlign: 'center',
                }}
            >
                <Box>
                    <Typography variant="h3" component="h1" sx={{
                        fontFamily: "'Wendell', 'Lora', 'sans-serif'",
                        textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
                        textAlign: 'center',
                    }}>
                        "Hyperborea's #1 TCG"
                    </Typography>
                    <Typography variant="h5" component="h2" sx={{
                        fontFamily: "'Wendell', 'Lora', 'sans-serif'",
                        textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
                        textAlign: 'center',
                    }}>
                        #vrilmaxxing
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Banner;